module.exports = __webpack_public_path__ + "img/facebook.2732bb5b.svg";